export default {
  payment: {},
  currentPayment: {},
  withdrawalPayment: {},
  secondaryWithdrawalPayment: {},
}
